import script from "./TextDimensionInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextDimensionInputs.vue?vue&type=script&setup=true&lang=ts"

import "./TextDimensionInputs.vue?vue&type=style&index=0&id=39146dfb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39146dfb"]])

export default __exports__